// TODO @zhaotjack please remove this when it is no longer needed
import StaffShift from '@/types/StaffShift';
import { ShiftState } from '@/types/Procedure';

export const mockStaff: StaffShift[] = [
  {
    id: 1,
    shiftState: ShiftState.Available,
    staff: {
      id: 1,
      name: 'John Doe',
      role: 'Nurse',
    },
    date: '2021-08-01',
    from: '08:00',
    to: '16:00',
    note: 'Note',
    openPosition: {
      id: 1,
      name: 'Nurse',
      description: 'Nurse description',
    },
    hourlyRate: 100,
  },
  {
    id: 2,
    shiftState: ShiftState.Available,
    staff: {
      id: 2,
      name: 'Jane Doe',
      role: 'Nurse',
    },
    date: '2021-08-02',
    from: '08:00',
    to: '16:00',
    note: 'Note',
    openPosition: {
      id: 2,
      name: 'Nurse',
      description: 'Nurse description',
    },
    hourlyRate: 100,
  },
  {
    id: 3,
    shiftState: ShiftState.Available,
    staff: {
      id: 3,
      name: 'John Smith',
      role: 'Nurse',
    },
    date: '2021-08-03',
    from: '08:00',
    to: '16:00',
    note: 'Note',
    openPosition: {
      id: 3,
      name: 'Nurse',
      description: 'Nurse description',
    },
    hourlyRate: 100,
  },
  {
    id: 3,
    shiftState: ShiftState.Available,
    staff: {
      id: 3,
      name: 'John Smith',
      role: 'Nurse',
    },
    date: '2021-08-03',
    from: '08:00',
    to: '16:00',
    note: 'Note',
    openPosition: {
      id: 3,
      name: 'Nurse',
      description: 'Nurse description',
    },
    hourlyRate: 100,
  },
  {
    id: 3,
    shiftState: ShiftState.Available,
    staff: {
      id: 3,
      name: 'John Smith',
      role: 'Nurse',
    },
    date: '2021-08-03',
    from: '08:00',
    to: '16:00',
    note: 'Note',
    openPosition: {
      id: 3,
      name: 'Nurse',
      description: 'Nurse description',
    },
    hourlyRate: 100,
  },
  {
    id: 3,
    shiftState: ShiftState.Available,
    staff: {
      id: 3,
      name: 'John Smith',
      role: 'Nurse',
    },
    date: '2021-08-03',
    from: '08:00',
    to: '16:00',
    note: 'Note',
    openPosition: {
      id: 3,
      name: 'Nurse',
      description: 'Nurse description',
    },
    hourlyRate: 100,
  },
];
